var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bookmark"}),_c('div',{staticClass:"content-container"},[_c('choice-message',{attrs:{"role":"button","format":_vm.format,"message":_vm.message}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }